import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_DEFAULT_VALUE_EMPLOYER_CONTRIBUTION_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
